import Types from "./Types";

const INITIAL_STATE = {
  studentExams: [],
  examSubmissions: [],
  correctionQuestions: [],
  correctedQuestions: [],
  examReportByChapter: [],
  isLoading: false,
  isQuestionsLoading: false,
  isCorrectedLoading: false,
  isSubmittingCorrection: false,
  count: 0,
};

export default function studentExams(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS: {
      return {
        ...state,
        studentExams: payload.data || payload,
        count: payload.total || (Array.isArray(payload.data) ? payload.data.length : (Array.isArray(payload) ? payload.length : 0)),
      };
    }

    case Types.REDO_EXAM_SUCCESS: {
      return {
        ...state,
      };
    }

    case Types.GET_STUDENT_EXAMS_BY_EXAM_SUCCESS: {
      return {
        ...state,
        examSubmissions: Array.isArray(payload) ? payload : payload?.data ?? [],
      };
    }

    case Types.GET_STUDENT_EXAMS_BY_EXAM_FAIL: {
      return {
        ...state,
        examSubmissions: [],
      };
    }

    case Types.GET_CORRECTION_QUESTIONS_REQUEST: {
      return {
        ...state,
        isQuestionsLoading: true,
        correctionQuestions: [],
      };
    }

    case Types.GET_CORRECTION_QUESTIONS_SUCCESS: {
      return {
        ...state,
        isQuestionsLoading: false,
        correctionQuestions: Array.isArray(payload) ? payload : payload?.data ?? [],
      };
    }

    case Types.GET_CORRECTION_QUESTIONS_FAIL: {
      return {
        ...state,
        isQuestionsLoading: false,
        correctionQuestions: [],
      };
    }

    case Types.CORRECT_STUDENT_EXAM_REQUEST: {
      return {
        ...state,
        isSubmittingCorrection: true,
      };
    }

    case Types.CORRECT_STUDENT_EXAM_SUCCESS: {
      return {
        ...state,
        isSubmittingCorrection: false,
      };
    }

    case Types.CORRECT_STUDENT_EXAM_FAIL: {
      return {
        ...state,
        isSubmittingCorrection: false,
      };
    }

    case Types.CLEAR_CORRECTION_QUESTIONS: {
      return {
        ...state,
        correctionQuestions: [],
        isQuestionsLoading: false,
        isSubmittingCorrection: false,
      };
    }

    case Types.GET_CORRECTED_QUESTIONS_REQUEST: {
      return {
        ...state,
        isCorrectedLoading: true,
        correctedQuestions: [],
      };
    }

    case Types.GET_CORRECTED_QUESTIONS_SUCCESS: {
      return {
        ...state,
        isCorrectedLoading: false,
        correctedQuestions: Array.isArray(payload) ? payload : payload?.data ?? [],
      };
    }

    case Types.GET_CORRECTED_QUESTIONS_FAIL: {
      return {
        ...state,
        isCorrectedLoading: false,
        correctedQuestions: [],
      };
    }

    case Types.CLEAR_CORRECTED_QUESTIONS: {
      return {
        ...state,
        correctedQuestions: [],
        isCorrectedLoading: false,
      };
    }

    case Types.GET_STUDENT_EXAM_REPORT_BY_CHAPTER_SUCCESS: {
      return {
        ...state,
        examReportByChapter: payload,
      };
    }

    case Types.GET_STUDENT_EXAM_REPORT_BY_CHAPTER_FAIL: {
      return {
        ...state,
        examReportByChapter: [],
      };
    }

    case Types.ADD_ADMIN_STUDENT_EXAMS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
}
